export default __webpack_public_path__ + "static/media/avatar.c6a0a4da.png";